import axios from 'axios'
import appConfig from '@/appconfig'
import store from '../store'
import constant from '@constants/constant'
import endpoint from '@constants/apipath'
import common from '@state/modules/common'

export const actions = {
  fetchWcoTransactions( { commit, dispatch, getters }, { beginDate, endDate }) {
    const url = `${appConfig.apiEndPoint}${endpoint.reportApiPath.getWcoTransactions}`

    return axios.get(
        `${url}?beginDate=${beginDate}&endDate=${endDate}`,
        { 
          headers: setHeaders(), 
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return error.response.status
        }
        return null
      })
  },
  
  downloadWcoTransactions({ commit, dispatch, getters }, { beginDate, endDate }) {
    const url = `${appConfig.apiEndPoint}${endpoint.reportApiPath.downloadWcoTransactions}`
    
    return axios.get(
        `${url}?beginDate=${beginDate}&endDate=${endDate}`,
        { 
          headers: setHeaders(), 
        }
      )
      .then((response) => {
        const reportName = `${constant.downloadWcoTransactionsName}_${beginDate}_${endDate}.csv`
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          var IECSV = common.fixUnicodeCharsCsv(response.data)
          var fullTemplate = [IECSV]
          var blob1 = new Blob(fullTemplate, { type: 'text/html' })
          window.navigator.msSaveOrOpenBlob(blob1, reportName)
        } else {
          const url = window.URL.createObjectURL(
            new Blob([common.fixUnicodeCharsCsv(response.data)])
          )
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', reportName)
          document.body.appendChild(link)
          link.click()
        }
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
}

function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}